import React, { createContext, useContext, useMemo } from "react";

const EmbedModeContext = createContext({
  isIframe: false,
  isGhlEmbed: false,
  ghlSsoToken: null,
});

export function useEmbedMode() {
  return useContext(EmbedModeContext);
}

export function EmbedModeProvider({ children }) {
  const value = useMemo(() => {
    const isIframe = typeof window !== "undefined" && window.self !== window.top;
    const params = new URLSearchParams(window.location.search);
    const ghlSsoToken = params.get("ghl_sso") || null;
    const isGhlEmbed = isIframe || params.get("ghl") === "1";
    return { isIframe, isGhlEmbed, ghlSsoToken };
  }, []);

  return (
    <EmbedModeContext.Provider value={value}>
      {children}
    </EmbedModeContext.Provider>
  );
}
